import { render, staticRenderFns } from "./PageBanner.vue?vue&type=template&id=122f8304"
import script from "./PageBanner.js?vue&type=script&lang=js&external"
export * from "./PageBanner.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports